<script setup lang="ts">
import { computed } from "vue";
import { RouterLink as VueRouterLink, useRouter, type RouteLocationRaw } from "vue-router";
import { useUserStore } from "@/stores/userStore";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  to: RouteLocationRaw;
}>();

const router = useRouter();
const userStore = useUserStore();

// Automatically append tenantId to the route so the rendered <a href> include it to accommodate cmd+click / "open in new tab"
const resolvedTo = computed<RouteLocationRaw>(() => {
  const tenantId = userStore.currentTenant?.id;
  if (!tenantId) return props.to;

  const resolved = router.resolve(props.to);
  if (resolved.path.startsWith("/admin")) return props.to;

  return {
    path: resolved.path,
    query: { ...resolved.query, tenantId: String(tenantId) },
    hash: resolved.hash,
  };
});
</script>

<template>
  <VueRouterLink v-bind="$attrs" :to="resolvedTo">
    <slot />
  </VueRouterLink>
</template>
